(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("gjV2B", function(module, exports) {
    $parcel$export(module.exports, "debounce", function() {
      return $be1aaad8d43db719$export$61fc7d43ac8f84b0;
    });
    const $be1aaad8d43db719$export$61fc7d43ac8f84b0 = (func, wait) => {
      let timeout;
      const debounced = (...args) => {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
      debounced.cancel = () => {
        clearTimeout(timeout);
        timeout = null;
      };
      return debounced;
    };
  });
  var $gjV2B = parcelRequire("gjV2B");
  var $73d4521db975695b$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("shopping-cart")) customElements.define("shopping-cart", class Cart extends HTMLElement {
      cart={};
      _isQuantityUpdate=false;
      facets=[ "[data-cart-items]", "[data-cart-promo]", "[data-cart-total]", "[data-cart-checkout]", "[data-cart-delivery]", "[data-cart-recommendations]", "[data-gift-wrap]", "[data-remove-packaging]", "[data-cart-gift-note]", "[data-cart-empty]", "[data-cart-payment-icons]", "[data-cart-shipping-indicator]" ];
      _requestQueue=new Map;
      _abortController=null;
      _updateController=null;
      _recommendationProductId=null;
      async fetchJSON(url, options = {}) {
        const response = await fetch(url, options);
        return response.ok ? response.json() : Promise.reject(response);
      }
      async fetchWithCancellation(url, options = {}, requestId = null) {
        if (requestId && this._requestQueue.has(requestId)) this._requestQueue.get(requestId).abort();
        const controller = new AbortController;
        const enhancedOptions = {
          ...options,
          signal: controller.signal
        };
        if (requestId) this._requestQueue.set(requestId, controller);
        try {
          const response = await fetch(url, enhancedOptions);
          if (requestId) this._requestQueue.delete(requestId);
          return response.ok ? response.json() : Promise.reject(response);
        } catch (error) {
          requestId && error.name;
          throw error;
        }
      }
      async update(sections = "cart,cart-drawer,header", facets = false) {
        const requestId = "update";
        if (this._updateController) this._updateController.abort();
        this._updateController = new AbortController;
        return this.fetchJSON(`${location.pathname}?sections=${sections}`, {
          signal: this._updateController.signal
        }).then(json => {
          Object.entries(json).forEach(([section, html]) => {
            if (!html) return;
            const parsed = (new DOMParser).parseFromString(html, "text/html");
            if (facets) (Array.isArray(facets) ? facets : [ facets ]).forEach(facet => {
              const replace = parsed.querySelector(facet);
              if (replace) this.querySelectorAll(facet).forEach(el => el.innerHTML = replace.innerHTML);
            });
            if (section === "header") [ "[data-header-cart-count]", "[data-cart-count]" ].forEach(selector => {
              const cartCount = parsed.querySelector(selector);
              if (cartCount) document.querySelectorAll(selector).forEach(el => el.innerHTML = cartCount.innerHTML);
            });
          });
          this._updateController = null;
        }).catch(error => {
          if (error.name !== "AbortError") {
            this._updateController = null;
            throw error;
          }
        });
      }
      toggleCart(open) {
        const checkbox = document.getElementById("Cart");
        if (checkbox && checkbox.checked !== open) checkbox.click();
        this.dispatchEvent(new Event("change"));
        if (open) this.dispatchEvent(new CustomEvent("cart:open", {
          bubbles: true,
          detail: {
            cart: this.cart
          }
        }));
      }
      open() {
        this.toggleCart(true);
      }
      close() {
        this.toggleCart(false);
      }
      dispatchCartUpdate() {
        this.dispatchEvent(new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            cart: this.cart
          }
        }));
      }
      updateCount() {
        this.update("header");
        this.updateFacets();
      }
      handleChange(event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (event?.target.hasAttribute("data-ignore-change")) return;
        const form = this.querySelector("[data-cart-items]");
        if (!form) return;
        this._isQuantityUpdate = event?.target && [ "data-quantity", "data-plus", "data-minus" ].some(attr => event.target.hasAttribute(attr));
        const formData = new URLSearchParams(new FormData(form));
        const noteInput = document.querySelector('cart-gift-note textarea, [name="note"]');
        if (noteInput) formData.set("note", noteInput.value.trim().replace(/\s+/g, " ").replace(/[<>]/g, ""));
        this.querySelectorAll(`input[type="checkbox"][name][form=${form.id}]`).forEach(cb => {
          formData.set(cb.name, cb.checked ? "true" : "false");
        });
        document.dispatchEvent(new CustomEvent("spinner:show", {
          detail: {
            source: "shopping-cart"
          }
        }));
        const requestId = "cart-update";
        this.fetchWithCancellation(Shopify.routes.root + "cart/update", {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }, requestId).then(cart => {
          if (event?.target.hasAttribute("data-ignore-update")) return;
          this.updateLinks(event?.target);
          this.cart = cart;
          this.dispatchCartUpdate();
          if (cart.items.length > 0) this.updateRecommendations(); else if (cart.item_count === 0) {
            this.removeAttribute("data-has-recommendations");
            this.update("cart,cart-drawer,header", this.facets);
          }
        }).catch(error => {
          if (error.name !== "AbortError") {
            console.warn(error);
            location.href = event?.target.href;
          }
        }).finally(() => {
          document.dispatchEvent(new CustomEvent("spinner:hide", {
            detail: {
              source: "shopping-cart"
            }
          }));
          this._isQuantityUpdate = false;
        });
      }
      setLineItemLoading(element, isLoading = true) {
        const row = element.closest("[data-line-item]");
        if (!row) return null;
        if (isLoading) {
          row.classList.add("opacity-50", "pointer-events-none");
          row.setAttribute("data-updating", "true");
        } else {
          row.classList.remove("opacity-50", "pointer-events-none");
          row.removeAttribute("data-updating");
        }
        return row;
      }
      updateLinks(el) {
        if (!el) return;
        const row = el.closest("[data-line-item]");
        if (!row) return this.updateCount();
        const matches = el.href?.match(/=([0-9]+)/);
        if (matches && matches[1]) {
          const qty = parseInt(matches[1]);
          const input = row.querySelector('[type="number"]');
          if (input) input.value = qty;
          if (qty <= 0) {
            row.classList.add("opacity-0", "max-h-0");
            setTimeout(() => row.remove(), 400);
          } else [ "[data-minus]", "[data-plus]" ].forEach((sel, i) => {
            const btn = row.querySelector(sel);
            if (btn) btn.href = btn.href.replace(/[0-9]+$/, qty + (i ? 1 : -1));
          });
        }
        this.updateCount();
      }
      updateFacets() {
        const facetsToUpdate = this._isQuantityUpdate ? this.facets.filter(f => f !== "[data-cart-recommendations]") : this.facets;
        this.update("cart,cart-drawer,header", facetsToUpdate);
      }
      updateRecommendations() {
        const firstRealItem = this.cart.items.find(item => !item.properties || item.properties._hidden !== "true");
        const product_id = firstRealItem?.product_id;
        if (!product_id) return;
        if (this._recommendationProductId === product_id) return;
        this._recommendationProductId = product_id;
        this.querySelectorAll("related-products").forEach(el => {
          const matches = el.dataset.url?.match(/product_id=([0-9]+)/);
          if (matches && parseInt(matches[1]) !== product_id) el.dataset.url = el.dataset.url.replace(matches[1], product_id);
          el.dispatchEvent(new CustomEvent("related-products:update", {
            detail: {
              productId: product_id,
              url: el.dataset.url
            }
          }));
        });
      }
      async handleClick(event) {
        const target = event.target.closest("[data-remove], [data-minus], [data-plus], [data-add]");
        if (!target) return;
        const hasAttr = attr => target.hasAttribute(attr);
        if (hasAttr("data-remove")) {
          const row = target.closest("[data-line-item]");
          if (row && row.hasAttribute("data-updating")) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            return;
          }
        }
        if (hasAttr("data-remove") || hasAttr("data-minus") || hasAttr("data-plus")) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          this.setAttribute("data-loading", "true");
          const loadingRow = hasAttr("data-remove") ? this.setLineItemLoading(target, true) : null;
          target.classList.add("pointer-events-none");
          document.dispatchEvent(new CustomEvent("spinner:show", {
            detail: {
              source: "shopping-cart"
            }
          }));
          this._isQuantityUpdate = hasAttr("data-plus") || hasAttr("data-minus");
          const requestId = `click-${target.dataset.remove || target.dataset.minus || target.dataset.plus}-${Date.now()}`;
          try {
            const url = new URL(target.href);
            const cart = await this.fetchWithCancellation(Shopify.routes.root + "cart/update.js", {
              method: "POST",
              body: url.searchParams,
              headers: {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }, requestId);
            if (cart.item_count === 0) {
              this.removeAttribute("data-has-recommendations");
              this.update("cart,cart-drawer,header", this.facets);
            } else {
              this.updateLinks(target);
              this.cart = cart;
              this.dispatchCartUpdate();
              if (cart.items.length > 0) this.updateRecommendations();
            }
          } catch (error) {
            if (error.name !== "AbortError") {
              console.warn(error);
              location.href = target.href;
            }
          } finally {
            document.dispatchEvent(new CustomEvent("spinner:hide", {
              detail: {
                source: "shopping-cart"
              }
            }));
            if (loadingRow) this.setLineItemLoading(target, false);
            target.classList.remove("pointer-events-none");
            this.removeAttribute("data-loading");
            this._isQuantityUpdate = false;
          }
        } else if (hasAttr("data-add")) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          target.classList.add("pointer-events-none");
          this.setAttribute("data-loading", "true");
          document.dispatchEvent(new CustomEvent("spinner:show", {
            detail: {
              source: "shopping-cart"
            }
          }));
          const requestId = `add-${target.dataset.add}-${Date.now()}`;
          try {
            await this.fetchWithCancellation(Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                items: [ {
                  id: parseInt(target.dataset.add),
                  quantity: 1
                } ]
              })
            }, requestId);
            this.update();
          } catch (error) {
            if (error.name !== "AbortError") {
              console.warn(error);
              location.href = target.href;
            }
          } finally {
            document.dispatchEvent(new CustomEvent("spinner:hide", {
              detail: {
                source: "shopping-cart"
              }
            }));
            target.classList.remove("pointer-events-none");
          }
        }
      }
      getCart(open = false) {
        const requestId = "get-cart";
        this.fetchWithCancellation(Shopify.routes.root + "cart.js", {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }, requestId).then(cart => {
          this.cart = cart;
          this.dispatchCartUpdate();
        }).catch(error => {
          if (error.name !== "AbortError") console.error(error);
        });
      }
      disconnectedCallback() {
        this._requestQueue.forEach(controller => controller.abort());
        this._requestQueue.clear();
        if (this._updateController) {
          this._updateController.abort();
          this._updateController = null;
        }
        if (this._cleanupSpinnerTranslation) this._cleanupSpinnerTranslation();
        if (this._cleanupSettings) this._cleanupSettings();
      }
      setupLoadingSpinnerTranslation() {
        const cartCheckbox = document.getElementById("Cart");
        const drawer = this.querySelector("[data-drawer]");
        const footer = this.querySelector("[data-footer]");
        if (!cartCheckbox || !drawer) {
          console.warn("ShoppingCart: Missing required elements, aborting spinner translation setup");
          return;
        }
        const mediaQuery = window.matchMedia("(min-width: 1024px)");
        const updateSpinnerPosition = () => {
          const isCartOpen = cartCheckbox.checked;
          if (isCartOpen) {
            if (mediaQuery.matches) {
              const drawerWidth = drawer.offsetWidth;
              document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
                detail: {
                  source: "shopping-cart-drawer",
                  transform: `translateX(-${drawerWidth}px)`
                }
              }));
            } else if (footer) {
              const footerRect = footer.getBoundingClientRect();
              const footerTranslateValue = footerRect.height;
              document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
                detail: {
                  source: "shopping-cart-drawer",
                  transform: `translateY(-${footerTranslateValue}px)`
                }
              }));
            } else console.warn("ShoppingCart: Footer not found for mobile transform calculation");
          } else document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
            detail: {
              source: "shopping-cart-drawer",
              transform: ""
            }
          }));
        };
        const handleCartToggle = () => {
          setTimeout(() => {
            updateSpinnerPosition();
          }, 10);
        };
        const handleMediaQueryChange = () => {
          if (cartCheckbox.checked) updateSpinnerPosition();
        };
        cartCheckbox.addEventListener("change", handleCartToggle);
        mediaQuery.addEventListener("change", handleMediaQueryChange);
        this._cleanupSpinnerTranslation = () => {
          cartCheckbox.removeEventListener("change", handleCartToggle);
          mediaQuery.removeEventListener("change", handleMediaQueryChange);
        };
      }
      connectedCallback() {
        this.getCart();
        this.openOnAdd = this.getAttribute("data-open-on-add") === "true";
        const broadcastConfig = () => {
          window.dispatchEvent(new CustomEvent("cart:settings", {
            detail: {
              openOnAdd: this.openOnAdd
            }
          }));
        };
        broadcastConfig();
        window.addEventListener("cart:settings-request", broadcastConfig);
        this.addEventListener("input", (0, $gjV2B.debounce)(event => this.handleChange(event), 300));
        this.closest(".shopify-section").addEventListener("click", event => this.handleClick(event));
        window.addEventListener("cart:added", () => {
          this.update("cart,cart-drawer,header", this.facets);
          if (this.openOnAdd) this.open();
        });
        window.addEventListener("cart:change", this.handleChange.bind(this));
        this.setupLoadingSpinnerTranslation();
        this._cleanupSettings = () => {
          window.removeEventListener("cart:settings-request", broadcastConfig);
        };
      }
    });
  })();
})();